<template>
    <img class="img-fluid img-visibility statement-logo" :src="require('@/assets/img/default_logo.png')">
</template>

<script>
import config from '@/config.js'
export default {
    // logoPath: require('@/' + this.config.institution_logo_path),
    // init() {
    //     // console.log('logoPath', this.logoPath);
    //     this.config = config;
    // },
    props:['institution'],
    data() {
    return {
      config: config
    }
    },
    computed: {
        // logoPath() {
        //     return require('@/' + this.config.institution_logo_path);
        // }
    }
}
</script>